import { path } from 'ramda';
import { HttpBadStatusCodeError } from '@cian/peperrors/shared';
import type { FetchResponse } from '@cian/http-api';

import {
  fetchAddTemporarily,
  TAddTemporarilyResponse,
  IAddTemporarilyRequest,
} from '../../repositories/encrypted-file-manager/v2/add-temporarily';
import { TThunkAction } from '../../types/redux';
import { EFileUploadErrorMessages } from './constants';
import { mapEncryptedFileToAttachedDocument } from './utils/mapEncryptedFileToAttachedDocument';
import { IAttachedDocument } from '../../types/requestFormValue';

export interface IUploadDocumentProps {
  file: File;
}

export const uploadFile =
  (props: IUploadDocumentProps): TThunkAction<Promise<IAttachedDocument>> =>
  async (_dispatch, _getState, context) => {
    const { httpApi, logger } = context;

    try {
      // TODO: нет решения от платформы как прокинуть multipart/form-data; boundary
      //  удалить request contentType: 'formData' из createAddTemporarilyModel
      const parameters = new FormData();
      parameters.append('attachments', props.file);

      const result: FetchResponse<TAddTemporarilyResponse> = await fetchAddTemporarily({
        httpApi,
        parameters: parameters as unknown as IAddTemporarilyRequest,
      });

      if (result.statusCode === 200) {
        return mapEncryptedFileToAttachedDocument(result.response);
      }

      throw new HttpBadStatusCodeError(
        `${EFileUploadErrorMessages.InvalidResponse}: ${(result.response as unknown as { message: string }).message}`,
        result.statusCode,
      );
    } catch (e) {
      const logPayload = {
        domain: 'actions/file#uploadFile',
        meta: {
          fileSize: path<number>(['size'], props.file),
          fileType: path<string>(['type'], props.file),
        },
      };

      if (HttpBadStatusCodeError.is(e)) {
        logger.warning(e, logPayload);

        throw e;
      }

      logger.error(e instanceof Error ? e : new Error(String(e)), logPayload);

      throw new Error(`Не удалось загрузить файл ${props.file.name}. Попробуйте еще раз.`);
    }
  };
